import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';
import React from 'react';

const MAX_PERCENTAGE = 99;

const UploadProgress = (props: LinearProgressProps & { value: number }): JSX.Element => {
  const progress = Math.min(MAX_PERCENTAGE, Math.floor(props.value));

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <Box
        sx={{
          marginRight: 1,
          width: '100%',
        }}
      >
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box
        sx={{
          minWidth: 35,
        }}
      >
        <Typography variant="body2">{`${progress}%`}</Typography>
      </Box>
    </Box>
  );
};

export default UploadProgress;
